'use client';
import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import styles from './offlineBanner.module.scss';
import { useNetworkStatus } from '@/app/_libs/hooks/useNetworkStatus';
type Props = {};
/* 
------------------------------------------- TODO --------------------------------------------
- Add additional logic for checking online/offline status, fetch a resource/ page from the app and validate the response
*/
export default function OfflineBanner({}: Props) {
  const [isOffline, setIsOffline] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean | null>(true);
  const [connectionMessage, setConnectionMessage] = useState<string>('');
  const online = useNetworkStatus();
  useEffect(() => {
    if (online) {
      setConnectionMessage("You're back online!");
      setIsError(false);
    } else {
      setConnectionMessage('No internet. Reconnect to continue.');
      setIsError(true);
    }
  }, [online]);
  // useEffect(() => {
  //   checkInternetConnection();
  //   window.addEventListener('offline', checkInternetConnection);
  //   window.addEventListener('online', checkInternetConnection);

  //   return () => {
  //     window.removeEventListener('offline', checkInternetConnection);
  //     window.removeEventListener('online', checkInternetConnection);
  //     setConnectionMessage('');
  //   };
  // }, []);

  // const checkInternetConnection = async () => {
  //   if (!window.navigator.onLine) {
  //     setIsOffline(true);
  //     setConnectionMessage('No internet. Reconnect to continue.');
  //     setIsError(true);
  //   } else {
  //     setConnectionMessage("You're back online!");
  //     setIsOffline(false);
  //     setIsError(false);
  //   }
  // };
  return (
    <>
      {!online && (
        <div className={styles.notificationWrapper}>
          <div
            className={`${styles.notification} ${
              isError ? styles.error : styles.success
            }`}
          >
            <WifiOff size={18} />
            <p>{connectionMessage}</p>
          </div>
        </div>
      )}
    </>
  );
}
